import { GridCellParams, GridColDef } from '@mui/x-data-grid-pro';
import React from 'react';
import ProjectNameCell from './Cells/ProjectNameCell/ProjectNameCell';
import OrderWorkunit from 'types/entities/OrderWorkunit';
import Scope from 'types/entities/Scope';
import User from 'types/entities/User';
import WorkunitComplexity from 'types/entities/WorkunitComplexity';
import Dashboard from 'types/entities/Dashboard';
import ActionsCell from './Cells/ActionsCell/ActionsCell';
import EngagementNameCell from './Cells/EngagementNameCell/EngagementNameCell';
import OrderTypeCell from './Cells/OrderTypeCell/OrderTypeCell';
import ClientCell from './Cells/ClientCell/ClientCell';
import OtpCell from './Cells/OtpCell/OtpCell';
import TypeCell from './Cells/TypeCell/TypeCell';
import OverdueByCell from './Cells/OverdueByCell/OverdueByCell';
import IDCell from './Cells/IDCell/IDCell';

type TodoTableGridCellParams<T> = GridCellParams<T, Dashboard, any>;

export const columnField = {
  PROJECT_NAME: 'project_name',
  ENGAGEMENT_NAME: 'engagement_name',
  CLIENT: 'client_name',
  OTP: 'otp',
  OVERDUE_BY: 'overdue_by',
  TYPE: 'type',
  ACTIONS: 'action_name',
  ORDER_TYPE: 'order_type',
  ID: 'id',
} as const;

// const defaultColumnParams: GridColDef = {
//   field: '',
//   headerName: '',
//   align: 'left',
//   headerAlign: 'center',
//   filterable: false,
//   sortable: true,
//   flex: 1,
// };

export const columnsParams = (data: any[]): GridColDef[] => {
  const getMaxWidth = (field: string, base = 100) =>
    Math.max(...data.map((row) => (row[field] ? String(row[field]).length * 10 : 0)), base) + 20;

  return [
    {
      field: columnField.PROJECT_NAME,
      headerName: 'Project Name',
      renderCell: (params: TodoTableGridCellParams<null>) => <ProjectNameCell {...params.row} />,
      resizable: true,
      minWidth: 320,
    },
    {
      field: columnField.ENGAGEMENT_NAME,
      headerName: 'Engagement Name',
      renderCell: (params: TodoTableGridCellParams<null>) => <EngagementNameCell {...params.row} />,
      resizable: true,
      minWidth: 320,
    },
    {
      field: columnField.ORDER_TYPE,
      headerName: 'Engagement Model',
      renderCell: (params: TodoTableGridCellParams<null>) => <OrderTypeCell {...params.row} />,
      resizable: true,
      minWidth: 180,
    },
    {
      field: columnField.CLIENT,
      headerName: 'Customer',
      renderCell: (params: TodoTableGridCellParams<null>) => <ClientCell {...params.row} />,
      resizable: true,
      minWidth: getMaxWidth(columnField.CLIENT, 200),
    },
    {
      field: columnField.OTP,
      headerName: 'OTP',
      renderCell: (params: TodoTableGridCellParams<null>) => <OtpCell {...params.row} />,
      resizable: true,
      minWidth: getMaxWidth(columnField.OTP, 120),
    },
    {
      field: columnField.OVERDUE_BY,
      headerName: 'Overdue by',
      renderCell: (params: TodoTableGridCellParams<null>) => <OverdueByCell {...params.row} />,
      resizable: true,
      minWidth: getMaxWidth(columnField.OVERDUE_BY, 100),
    },
    {
      field: columnField.TYPE,
      headerName: 'Type',
      renderCell: (params: TodoTableGridCellParams<null>) => <TypeCell {...params.row} />,
      resizable: true,
      minWidth: getMaxWidth(columnField.TYPE, 150),
    },
    {
      field: columnField.ACTIONS,
      headerName: 'Actions',
      renderCell: (params: TodoTableGridCellParams<null>) => <ActionsCell {...params.row} />,
      resizable: true,
      // align: 'center',
      // headerAlign: 'center',
      minWidth: 200,
      // disableColumnMenu: true,
    },
    // ...repeat for other columns
  ];
};
